import script from "./BusesSidebarDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BusesSidebarDetails.vue?vue&type=script&setup=true&lang=js"

import "./BusesSidebarDetails.vue?vue&type=style&index=0&id=59134ca7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59134ca7"]])

export default __exports__